@if (reviewOK) {
  <div>
    <h2>Dashboard</h2>
    <responses></responses>
  </div>
} @else {
  You are not an authorised reviewer
}
